import type { MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageSenderBasicInfo } from './messagingGetChatRooms200PageAllOfThreeContentItemLastMessageSenderBasicInfo';
import type { MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageSenderSocial } from './messagingGetChatRooms200PageAllOfThreeContentItemLastMessageSenderSocial';

/**
 * 발신자 정보
 */
export type MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageSender = {
  /** 사용자 기본 정보 */
  basicInfo: MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageSenderBasicInfo;
  /** 소셜 관계 정보 */
  social?: MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageSenderSocial;
};
